<template>
  <Button
    v-if="!storeLoader.load[4] && storeTrail.ableToQuiz"
    id="quiz"
    :class="[
    'w-full !text-h-neutral-800 !rounded-b !rounded-t-none btn-light',
    storeChapter.currentChapter!.done
      ? '!bg-green-100 !text-h-success-800'
      : 'btn-light',
  ]"
    @click.prevent="storeQuiz.onShowQuiz"
    :disabled="storeChapter.currentChapter!.done || storeLoader.load[4]
  "
  >
    <div class="flex items-center gap-2 justify-between w-full">
      <div class="flex items-center gap-2">
        <v-icon
          name="hi-solid-check-circle"
          :class="[storeChapter.currentChapter!.done ? 'text-green-500' : '']"
        />
        <p class="font-bold">{{ "Quiz" }}</p>
      </div>
      <v-icon name="md-helpoutline" />
    </div>
  </Button>
</template>

<script lang="ts">
import { useChapterStore } from "@/store/linear/chapter";
import { useLoaderStore } from "@/store/linear/loader";
import { useMaterialStore } from "@/store/linear/material";
import { useQuizStore } from "@/store/linear/quiz";
import { useTrailStore } from "@/store/linear/trail";
import { computed, defineComponent } from "vue";
export default defineComponent({
  name: "QuizTrigger",
  setup() {
    const storeQuiz = useQuizStore;
    const storeChapter = useChapterStore;
    const storeLoader = useLoaderStore;
    const storeTrail = useTrailStore;
    const storeMaterial = useMaterialStore;

    const permissQuiz = computed(() => {
      const removedLast = storeTrail.trails.splice(-1);
      const trails = removedLast.every((e) => e.done);
      return trails;
    });

    return {
      storeQuiz,
      storeChapter,
      storeTrail,
      storeMaterial,
      storeLoader,
      permissQuiz,
    };
  },
});
</script>
